export const USER_REGISTER = 'USER_REGISTER';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_AUTH = 'USER_AUTH';

export const USER_LOADED = 'USER_LOADED';

export const REGISTER_ERROR = 'REGISTER_ERROR';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const  LOGIN_SUCCESS = ' LOGIN_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';

export const LOGOUT = 'LOGOUT';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';

export const GET_ALL_MEMBERS = 'GET_ALL_MEMBER';
export const GET_MEMBER = 'GET_MEMBER';
export const DELETE_MEMBER = 'DELETE_MEMBER';

export const UPDATE_MEMBER = 'UPDATE_MEMBER';
export const ADD_MEMBER = 'ADD_MEMBER';

//@donation
export const GET_ALL_DONATORS = 'GET_ALL_DONATOR';
export const GET_DONATOR = 'GET_DONATOR';
export const DELETE_DONATOR = 'DELETE_DONATOR';

export const UPDATE_DONATOR = 'UPDATE_DONATOR';
export const ADD_DONATOR = 'ADD_DONATOR';

//@mission
export const GET_ALL_MISSIONS = 'GET_ALL_MISSION';
export const GET_MISSION = 'GET_MISSION';
export const DELETE_MISSION = 'DELETE_MISSION';

export const UPDATE_MISSION = 'UPDATE_MISSION';
export const ADD_MISSION = 'ADD_MISSION';

export const GET_ALL_GOV_GROUPS = 'GET_ALL_GOV_GROUPS';